import { client } from '../http';

async function fetchOnboardingState() {
  const response = await client.get('/api/onboarding-state');
  return response.data;
}

async function nextOnboardingPage() {
  const response = await client.post('/api/onboarding-state/next-page');
  return response.data;
}

async function back() {
  const response = await client.post('/api/onboarding-state/back');
  return response.data;
}

async function updateOnboardingPage(onboardingPage) {
  const response = await client.put('/api/onboarding-state', { onboardingPage });
  return response.data;
}

export default {
  nextOnboardingPage,
  fetchOnboardingState,
  updateOnboardingPage,
  back,
};
